import { ReceiptDetailPanelBase } from "./shared/ReceiptDetailPanelBase";
import { receiptDetailExamplesNutripur } from "./ReceiptDetailExamplesNutripur";

export const ReceiptDetailPanelNutripur = () => (
  <ReceiptDetailPanelBase 
    examples={receiptDetailExamplesNutripur} 
    imageFolder="productImagesNutripur" 
  />
);